import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

function handleNotFoundError(req: HttpRequest<unknown>, err: HttpErrorResponse): Observable<any> {
  // Only redirect for browser navigation-like 404s, not API calls.
  const isApiCall = req.url.includes("/explore/flock/") || req.url.includes("/api/");
  if (err.status === 404 && !isApiCall) {
    window.location.href = window.location.origin + "/not-found";
  }
  return throwError(() => err);
}

export function notFoundInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  return next(req).pipe(catchError((x) => handleNotFoundError(req, x))) as Observable<HttpEvent<unknown>>;
}
